// extracted by mini-css-extract-plugin
export default {"reactSwitch":"ThemeSwitcher_reactSwitch__Lt2Fa","container":"ThemeSwitcher_container__ntLZI"};